import type { components } from "@/types/api-schema";

export enum RunStatus {
  ACCEPTED = "accepted",
  RUNNING = "running",
  COMPLETED = "completed",
  FAILED = "failed",
}

export type FieldDef = components["schemas"]["Application.TaskTypes.FieldDef"];
export type TaskType = components["schemas"]["Application.TaskTypes.TaskType"];

export type UseCaseRun =
  components["schemas"]["Playback.TwinAi.Controllers.TaskTypes.ContentUseCaseRunsController.UseCaseRunResponse"];
export type RunsPage =
  components["schemas"]["Playback.TwinAi.Controllers.Shared.PaginatedResponseOfPlayback.TwinAi.Controllers.TaskTypes.ContentUseCaseRunsController.UseCaseRunResponse"];

export interface RunOutputs {
  video_url?: string;
  thumbnail_url?: string;
  duration_seconds?: number;
  scene_count?: number;
  image_url?: string;
  image_urls?: string[];
  [key: string]: unknown;
}

export type RunInputs = Record<string, unknown>;
